import { CUP_GRATITUDE_APIS } from "libs/apis/cup-of-gratitude.api";
import { PRODUCT_ITEM_APIS } from "libs/apis/product-item.api";
import { useNavigate } from "react-router-dom";
import { successToaster } from "utils/helpers/common/alert-service";

const useProductItem = () => {
  const navigate = useNavigate();
  const uploadFile = async (params: FormData): Promise<string | null> => {
    try {
      const response = await PRODUCT_ITEM_APIS.uploadFile(params);
      const { status = false, message = "", data = null } = response || {};

      if (status && data) {
        return data;
      }

      return null;
    } catch (error) {
      console.error("Upload failed", error);
      return null;
    }
  };

  const createProductItems = async (body: any) => {
    const response = await PRODUCT_ITEM_APIS.createProductItems(body);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const activateMember = async (userId: number) => {
    const response = await PRODUCT_ITEM_APIS.activateMember(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const deactivateMember = async (userId: number) => {
    const response = await PRODUCT_ITEM_APIS.deactivateMember(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const getProductItems = async (setData: Function, queryParams: any) => {
    const response = await PRODUCT_ITEM_APIS.getProductItems(queryParams);
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data?.products || []);
    }
  };

  const getProductItemById = async (id: number, setData: Function) => {
    const response = await PRODUCT_ITEM_APIS.getProductItemById(id);
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data?.product || {});
    }
  };

  const updateProductItemById = async (id: number, body: any) => {
    const response = await PRODUCT_ITEM_APIS.updateProductItemById(id, body);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const updateProductItemStatus = async (userId: number, body: any) => {
    const response = await PRODUCT_ITEM_APIS.updateProductItemStatus(
      userId,
      body
    );
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const getOrderRequest = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await PRODUCT_ITEM_APIS.getOrderRequest(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;
      setData(content);
      setFilters((prev) => ({
        ...prev,
        page: pageNumber + 1,
        limit: pageSize,
      }));
      setTotalElements?.(totalElements);
    }
  };

  const getOrderProductById = async (
    queryParams: any = {},
    setData: Function
  ) => {
    const response = await PRODUCT_ITEM_APIS.getOrderProductById(queryParams);
    const { status = false, data = {} } = response || {};
    if (status) {
      setData(data || {});
    }
  };

  const createConsigneinfo = async (queryParams: any = {}, body: any) => {
    const response = await PRODUCT_ITEM_APIS.createConsigneinfo(
      queryParams,
      body
    );
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  return {
    uploadFile,
    createProductItems,
    getProductItems,
    updateProductItemById,
    getProductItemById,
    updateProductItemStatus,
    getOrderRequest,
    getOrderProductById,
    createConsigneinfo,
  };
};

export default useProductItem;
